const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M16.64 -1.43051e-06C16.912 -1.43051e-06 17.144 0.0959988 17.336 0.287999C17.544 0.48 17.648 0.72 17.648 1.008C17.648 1.072 17.632 1.184 17.6 1.344L15.68 6.864C14.4 10.56 13.112 14.256 11.816 17.952C10.52 21.632 9.856 23.504 9.824 23.568C9.6 23.84 9.32 23.976 8.984 23.976C8.76 23.976 8.56 23.912 8.384 23.784C8.272 23.704 8.184 23.584 8.12 23.424C7.928 22.976 6.64 19.328 4.256 12.48C3.664 10.8 3.032 9 2.36 7.08C1.704 5.16 1.208 3.736 0.872 2.808C0.552 1.864 0.384 1.376 0.368 1.344C0.336 1.184 0.32 1.072 0.32 1.008C0.32 0.736 0.408 0.503999 0.584 0.311999C0.776 0.103999 1.008 -1.43051e-06 1.28 -1.43051e-06C1.648 -1.43051e-06 1.944 0.151999 2.168 0.456C2.184 0.487999 2.416 1.152 2.864 2.448C3.328 3.728 3.888 5.304 4.544 7.176C5.2 9.032 5.848 10.88 6.488 12.72C7.128 14.56 7.696 16.192 8.192 17.616C8.688 19.024 8.952 19.784 8.984 19.896C9.96 17.112 10.872 14.496 11.72 12.048C12.584 9.6 13.24 7.736 13.688 6.456C14.136 5.16 14.528 4.024 14.864 3.048C15.2 2.072 15.432 1.408 15.56 1.056C15.688 0.703999 15.768 0.503999 15.8 0.456C16.04 0.151999 16.32 -1.43051e-06 16.64 -1.43051e-06Z",
  fill: "#1E3F6B"
});

const SvgEquationIntegrals7 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationIntegrals7, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-integrals-7.c13b9785.svg";
export { ForwardRef as ReactComponent };